import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleStyle } from './productCell.css';

type Props = {
  name: string | null;
};

export const ProductNameCell = ({ name }: Props) => <span className={clsx(desktopTruncateStyle, titleStyle)}>{name}</span>;
